(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6183],{

/***/ 35420:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _imageUrl = _interopRequireDefault(__webpack_require__(6803));
var _getWindow2 = _interopRequireDefault(__webpack_require__(27203));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DEFAULT_PIXEL_RATIO = 1;
var imageUrlBuilder = function imageUrlBuilder(config) {
  return function (source) {
    var _getWindow$devicePixe, _getWindow;
    var devicePixelRatio = (_getWindow$devicePixe = (_getWindow = (0, _getWindow2["default"])()) === null || _getWindow === void 0 ? void 0 : _getWindow.devicePixelRatio) !== null && _getWindow$devicePixe !== void 0 ? _getWindow$devicePixe : DEFAULT_PIXEL_RATIO;
    return (0, _imageUrl["default"])({
      dataset: config.dataset,
      projectId: config.projectId
    }).image(source).auto('format') // raster formats will use webp where available instead of png/jpg.
    .dpr(Math.min(5, devicePixelRatio)) // Set device pixel ratio when available (2x/3x res for retina screens).
    .fit('max') // Don't enlarge images when source image is smaller than width/height.
    .quality(80).width(5) // Set a tiny default, so we fail tiny and obvious instead of ruining performance.
    .height(5); // Set a tiny default, so we fail tiny and obvious instead of ruining performance.
  };
};
var _default = exports["default"] = imageUrlBuilder;
module.exports = exports.default;

/***/ }),

/***/ 27203:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var getWindow = function getWindow() {
  return typeof window !== 'undefined' ? window : null;
};
var _default = exports["default"] = getWindow;
module.exports = exports.default;

/***/ }),

/***/ 51938:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/perks",
      function () {
        return __webpack_require__(70537);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 70537:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ index_page; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(40872);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/lodash/fp.js
var fp = __webpack_require__(78230);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/client/models/table-of-contents/constants/index.ts
var constants = __webpack_require__(3971);
// EXTERNAL MODULE: ./src/client/utils/get-should-skip-client-side-request/index.ts
var get_should_skip_client_side_request = __webpack_require__(14033);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_array_with_holes.mjs
var _array_with_holes = __webpack_require__(39474);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_non_iterable_rest.mjs
var _non_iterable_rest = __webpack_require__(53128);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_to_array.mjs





function _toArray(arr) {
  return (0,_array_with_holes/* default */.Z)(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr, i) || (0,_non_iterable_rest/* default */.Z)();
}

// EXTERNAL MODULE: ./node_modules/@ahmdigital/ui/lib/ahm-ui.js
var ahm_ui = __webpack_require__(37169);
// EXTERNAL MODULE: ./src/client/ahm-constants/ui.ts
var ui = __webpack_require__(93590);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
;// CONCATENATED MODULE: ./src/client/pages/perks/listing/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 4rem 2rem;\n\n  @media (min-width: ",
        ") {\n    grid-template-columns: repeat(2, 1fr);\n    display: grid;\n    gap: 4rem 2rem;\n  }\n\n  @media (min-width: ",
        ") {\n    grid-template-columns: repeat(3, 1fr);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: none;\n\n  @media (min-width: ",
        ") {\n    max-width: 27rem;\n  }\n\n  @media (max-width: ",
        ") {\n    margin-bottom: 2rem;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var PerksContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-dfa683ca-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.media.md;
}, function(param) {
    var theme = param.theme;
    return theme.media.lg;
});
var StyledPerkTile = (0,styled_components_browser_esm["default"])(ahm_ui/* PerkTile */.P7).withConfig({
    componentId: "sc-dfa683ca-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.media.lg;
}, function(param) {
    var theme = param.theme;
    return theme.media.md;
});

// EXTERNAL MODULE: ./src/client/cms/utils/perks/build-cta-props/index.ts
var build_cta_props = __webpack_require__(62457);
// EXTERNAL MODULE: ./src/utils/head.tsx
var head = __webpack_require__(40985);
// EXTERNAL MODULE: ./src/client/cms/utils/image-url-builder/index.ts
var image_url_builder = __webpack_require__(36175);
;// CONCATENATED MODULE: ./src/client/pages/perks/listing/index.tsx










var PerksListing = function(param) {
    var _perks = param.perks, perks = _perks === void 0 ? [] : _perks;
    var ref, ref1, ref2, ref3;
    var _perks1 = _toArray(perks), featuredPerk = _perks1[0], perksWithoutFeatured = _perks1.slice(1);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(head/* default */.Z, {
                titleTemplate: ui.PAGE_TITLE_TEMPLATE,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "ahm Perks and Member Offers"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Want more bang for your buck? Health members get access to discounts on other insurance like Travel & Car, plus offers on glasses, movie tickets, and more."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* HeroBanner */.yo, {
                cta: {
                    title: (ref = (0,build_cta_props/* default */.Z)(featuredPerk)) === null || ref === void 0 ? void 0 : ref.ctaText,
                    to: (ref1 = (0,build_cta_props/* default */.Z)(featuredPerk)) === null || ref1 === void 0 ? void 0 : ref1.ctaUrl
                },
                image: {
                    alt: featuredPerk === null || featuredPerk === void 0 ? void 0 : (ref2 = featuredPerk.imageObject) === null || ref2 === void 0 ? void 0 : ref2.caption,
                    // @ts-expect-error - Automatic, Please fix when editing this file
                    src: (0,image_url_builder/* default */.Z)(featuredPerk === null || featuredPerk === void 0 ? void 0 : (ref3 = featuredPerk.imageObject) === null || ref3 === void 0 ? void 0 : ref3.image).width(undefined).height(116).url()
                },
                title: featuredPerk === null || featuredPerk === void 0 ? void 0 : featuredPerk.name,
                subtitle: featuredPerk === null || featuredPerk === void 0 ? void 0 : featuredPerk.slogan,
                hasCTAIcon: false,
                isFeaturedOffer: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* BorderGridContainer */.sO, {
                hideBorderTop: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* GridBox */.zc, {
                    padding: "0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PerksContainer, {
                        children: (0,fp.map)(function(perk) {
                            var ref, ref1, ref2, ref3, ref4;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(StyledPerkTile, {
                                cta: {
                                    title: (ref = (0,build_cta_props/* default */.Z)(perk)) === null || ref === void 0 ? void 0 : ref.ctaText,
                                    to: (ref1 = (0,build_cta_props/* default */.Z)(perk)) === null || ref1 === void 0 ? void 0 : ref1.ctaUrl
                                },
                                logo: {
                                    // @ts-expect-error - Automatic, Please fix when editing this file
                                    src: (0,image_url_builder/* default */.Z)(perk === null || perk === void 0 ? void 0 : (ref2 = perk.offeredBy) === null || ref2 === void 0 ? void 0 : ref2.logo).width(undefined).height(40).url()
                                },
                                image: {
                                    alt: perk === null || perk === void 0 ? void 0 : (ref3 = perk.imageObject) === null || ref3 === void 0 ? void 0 : ref3.caption,
                                    // @ts-expect-error - Automatic, Please fix when editing this file
                                    src: (0,image_url_builder/* default */.Z)(perk === null || perk === void 0 ? void 0 : (ref4 = perk.imageObject) === null || ref4 === void 0 ? void 0 : ref4.image).width(undefined).height(116).url()
                                },
                                name: perk === null || perk === void 0 ? void 0 : perk.name
                            }, perk === null || perk === void 0 ? void 0 : perk.name);
                        }, perksWithoutFeatured)
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var listing = (PerksListing);

// EXTERNAL MODULE: ./src/client/cms/utils/use-table-of-contents/index.ts
var use_table_of_contents = __webpack_require__(30329);
;// CONCATENATED MODULE: ./pages/perks/index.page.tsx









var PERKS_IDENTIFIER = "perks-page";
var PerksLandingPage = function(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    var shouldSkipClientQuery = (0,get_should_skip_client_side_request/* default */.Z)();
    var ref = (0,use_table_of_contents/* default */.Z)({
        fragment: constants/* FRAGMENTS.PERKS */.Y.PERKS,
        skip: shouldSkipClientQuery,
        slug: PERKS_IDENTIFIER
    }), perksRaw = ref.items, arePerksLoading = ref.loading;
    if (shouldSkipClientQuery || arePerksLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(listing, (0,_object_spread/* default */.Z)({}, props));
    }
    var perks = (0,fp.map)("item", perksRaw);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(listing, {
        perks: perks
    });
};
var __N_SSP = true;
/* harmony default export */ var index_page = (PerksLandingPage);


/***/ }),

/***/ 36175:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _ahmdigital_logic_lib_utils_sanity_image_url_builder__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35420);
/* harmony import */ var _ahmdigital_logic_lib_utils_sanity_image_url_builder__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_ahmdigital_logic_lib_utils_sanity_image_url_builder__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6465);


/**
 * @param {object} source - Object from Sanity that contains information about the image.
 * @returns {object} Object that can be called with many functions to override behaviour.
 * To override sizing while preserving aspect ratio you can set either height or width to undefined.
 * If you currently have SVG sources, upload a jpg, or just set `.format('jpg')` to test your sizing is reasonable.
 * NOTE: for more detail on the usage of the imageUrlBuilder see https://www.sanity.io/docs/image-url.
 */ // @ts-expect-error - Automatic, Please fix when editing this file
var imageUrlBuilder = function(source) {
    return _ahmdigital_logic_lib_utils_sanity_image_url_builder__WEBPACK_IMPORTED_MODULE_0___default()({
        dataset: _client__WEBPACK_IMPORTED_MODULE_1__/* ["default"].dataset */ .Z.dataset,
        projectId: _client__WEBPACK_IMPORTED_MODULE_1__/* ["default"].projectId */ .Z.projectId
    })(source);
};
/* harmony default export */ __webpack_exports__["Z"] = (imageUrlBuilder);


/***/ }),

/***/ 62457:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _elements_header_utils_extract_perk_url__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29561);


// @ts-expect-error - Automatic, Please fix when editing this file
var buildCtaProps = function(perk) {
    var ctaText = perk === null || perk === void 0 ? void 0 : perk.descriptionTeaser;
    if ((0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isNil)(ctaText)) {
        var ref;
        ctaText = perk === null || perk === void 0 ? void 0 : (ref = perk.urlObject) === null || ref === void 0 ? void 0 : ref.name;
    }
    return {
        ctaText: ctaText,
        ctaUrl: (0,_elements_header_utils_extract_perk_url__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(perk)
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (buildCtaProps);


/***/ }),

/***/ 14033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _cms_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28937);
/* harmony import */ var _cms_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6465);


var getShouldSkipClientSideRequest = function() {
    var useLiveFiltering = _cms_client__WEBPACK_IMPORTED_MODULE_1__/* ["default"].useLiveFiltering */ .Z.useLiveFiltering, asAtDate = _cms_client__WEBPACK_IMPORTED_MODULE_1__/* ["default"].asAtDate */ .Z.asAtDate, asAtTime = _cms_client__WEBPACK_IMPORTED_MODULE_1__/* ["default"].asAtTime */ .Z.asAtTime, dataset = _cms_client__WEBPACK_IMPORTED_MODULE_1__/* ["default"].dataset */ .Z.dataset;
    return !useLiveFiltering || asAtDate === _cms_constants__WEBPACK_IMPORTED_MODULE_0__/* .NOW */ .Kp && asAtTime === _cms_constants__WEBPACK_IMPORTED_MODULE_0__/* .MIDDAY */ .T3 && dataset === _cms_constants__WEBPACK_IMPORTED_MODULE_0__/* .DATASET.PRODUCTION */ .tz.PRODUCTION;
};
/* harmony default export */ __webpack_exports__["Z"] = (getShouldSkipClientSideRequest);


/***/ }),

/***/ 40872:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function extends_() {
  extends_ = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return extends_.apply(this, arguments);
}

function _extends() {
  return extends_.apply(this, arguments);
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(51938); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);